import React from 'react';

const Tokenomics = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-900 to-black relative overflow-hidden" id="tokenomics">
      {/* Radial gradient background effect */}
      <div className="absolute inset-0 bg-gradient-radial from-yellow-500/5 via-transparent to-transparent"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-16 bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text text-transparent">
          Tokenomics
        </h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {/* LP Card */}
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl p-8 hover:-translate-y-2 transition-all duration-300 border border-yellow-400/10 hover:border-yellow-400/20 group">
            <div className="text-center">
              <h3 className="text-2xl font-bold text-yellow-400 mb-3 group-hover:scale-110 transition-transform">
                2% LP
              </h3>
              <p className="text-gray-300">
                Automatically added to liquidity
              </p>
            </div>
          </div>

          {/* Marketing Card */}
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl p-8 hover:-translate-y-2 transition-all duration-300 border border-yellow-400/10 hover:border-yellow-400/20 group">
            <div className="text-center">
              <h3 className="text-2xl font-bold text-yellow-400 mb-3 group-hover:scale-110 transition-transform">
                2% Marketing
              </h3>
              <p className="text-gray-300">
                For continuous project growth
              </p>
            </div>
          </div>

          {/* Charity Card */}
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl p-8 hover:-translate-y-2 transition-all duration-300 border border-yellow-400/10 hover:border-yellow-400/20 group">
            <div className="text-center">
              <h3 className="text-2xl font-bold text-yellow-400 mb-3 group-hover:scale-110 transition-transform">
                1% Charity
              </h3>
              <p className="text-gray-300">
                Supporting religious causes
              </p>
            </div>
          </div>

          {/* Circulating Card */}
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl p-8 hover:-translate-y-2 transition-all duration-300 border border-yellow-400/10 hover:border-yellow-400/20 group">
            <div className="text-center">
              <h3 className="text-2xl font-bold text-yellow-400 mb-3 group-hover:scale-110 transition-transform">
                95% Circulating
              </h3>
              <p className="text-gray-300">
                Available for trading
              </p>
            </div>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-16 max-w-3xl mx-auto text-center">
          <p className="text-gray-300 mb-8">
            Our tokenomics are designed to ensure sustainable growth and community benefits
          </p>
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl p-6 border border-yellow-400/10">
            <h4 className="text-yellow-400 font-semibold mb-4">Total Supply</h4>
            <p className="text-3xl font-bold bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text text-transparent">
              1,000,000,000 $HFP
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tokenomics; 